
import React, { useLayoutEffect } from "react";
import { Col, Modal, Row, Container } from "react-bootstrap";
import IconWithButton from "../IconWithButton/IconWithButton";
import './alertPopup.scss';
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import {
    getCompleteStatusCheckAction,
    resetCompleteStatusCheckStateAction,
    getFeeSchedulesCheckAction,
    resetFeeScheduleCheckStateAction,
  } from "../../components/dataEntryDetails/DataEntryDetailsDucks";
import { DISCLOSURE_ACCOUNTING } from "../../models/requestType";

interface Props {
    setCompleteTransactionPopUp?: any,
    transactionID?: string,
    completeTransaction: any,
    getNextTransactionId: (facilityId: number, context: number) => void,
    goToNextTransaction: any,
    facilityId: number,
    organizationId: number,
    onChangeDataEntryTab: any,
    activeTabId: any,
    setWait: any,
    requestType?: number,
    setCreateNewTransactionComplete?: any,
    createTransaction: (data: { facilityId: number }) => void,
    clearUserLocks?: any,
    isCreateTransaction?: any,
    clearPreviousTransactionOnComplete?: any,
    requestContext: any,
    resetRequestContext: Function,
    setCloseTranctionComplete: Function,
    closeTranctioncomplete: boolean,
    resetCompleteStatusCheck: Function,
    getCompleteStatusCheck: Function,
    completeStatusCheck: any,
    getFeeSchedulesCheck: (transactionId: string) => void,
    resetFeeScheduleCheck: ()  => void,
    feeSchedulesCheck: boolean
}

function CompleteTransactionPopUp(props: Props) {

    const {setCompleteTransactionPopUp, transactionID, setCreateNewTransactionComplete} = props
    const history = useHistory();

    const onclickCancelhandler = () => {
        onClose()
        setCompleteTransactionPopUp(false)
        setCreateNewTransactionComplete(false)
    }

    const onClickYesHandler = () => {
        onClose()
        setCompleteTransactionPopUp(false)
        props.completeTransaction(transactionID)

        if (props.requestType && props.requestType != DISCLOSURE_ACCOUNTING) {
            if (props.isCreateTransaction) {
                props.resetRequestContext();
                setCreateNewTransactionComplete(false)
                props.setWait(true);
                setTimeout(()=>{
                    props.setWait(false);
                    props.clearPreviousTransactionOnComplete && props.clearPreviousTransactionOnComplete()
                    props.createTransaction && props.createTransaction({ facilityId: props.organizationId })
                    props.clearUserLocks && props.clearUserLocks()
                    props.onChangeDataEntryTab(1, false)
                }, 1000)
            } else if(props.closeTranctioncomplete) {
                props.setCloseTranctionComplete(false)
                props.resetRequestContext();
                history?.push("/home")
            } else {
                props.setWait(true);
                setTimeout(() => {
                    props.setWait(false);
                    props.clearPreviousTransactionOnComplete && props.clearPreviousTransactionOnComplete()
                    props.getNextTransactionId(props.facilityId, props.requestContext);
                    props.onChangeDataEntryTab(1, false)
                }, 1000);
            }
        }
        else{
            props.setCloseTranctionComplete(false)
            props.resetRequestContext();
            history?.push("/home")
        }
    }

    const onClose = () => {
        props.resetCompleteStatusCheck();
        props.resetFeeScheduleCheck();
    }

    useLayoutEffect(() => {
        props.getCompleteStatusCheck(transactionID);
        if(transactionID != null)
        {
            props.getFeeSchedulesCheck(transactionID);
        }
    },[]);
    
    return (
        <div>
            <Modal className="cancel-dimension complete-transaction-modal" show={true}>
                <div className="alert-container">
                    <Modal.Title className="cancel-header">
                        <span className="info-icon"></span>
                        <div className="cancel-header-text">Complete ROIS Processing - {transactionID}</div>
                    </Modal.Title>
                    <Modal.Body>
                    <Container style={{display: "flex", flexDirection: "column"}}>
                    {props.feeSchedulesCheck === false ?
                    <>
                     <Row style={{textAlign:"center"}}>
                                <Col xs={12}>
                                <Row>
                                    <Col xs={12}>
                                        <div className="delete-confirmation-text">
                                             <p>
                                               Unable to complete due to missing fee schedules on documents
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="button-align">
                                    <Col xs={3} md={3} className="d-flex justify-content-center align-items-center">
                                        <a href="#!" onClick={onclickCancelhandler} className="modal-cancel" style={{marginLeft: "0"}}>
                                            Cancel
                                        </a>
                                    </Col>
                                </Row>
                                </Col>
                            </Row> 
                    </> :
                    <>
                        { props.completeStatusCheck.status && props.feeSchedulesCheck != undefined ? 
                        <>
                            <Row style={{textAlign:"center"}}>
                                <Col xs={12}>
                                <Row>
                                    <Col xs={12}>
                                        <div className="delete-confirmation-text">
                                            { props.completeStatusCheck.statusId != "0" ?
                                                <p>
                                                    By selecting to complete, I affirm the information entered is truthful and accurate.
                                                </p>
                                            :
                                                <p>
                                                    {props.completeStatusCheck.status}
                                                </p>
                                            }
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12}>
                                        {props.completeStatusCheck.statusId != "0" &&
                                        <div id="NewStatus" className="alert-text-background-blue" >
                                            <p className="mb-0" style={{ textAlign: "center" }}>
                                                The transaction status will change to <b>{props.completeStatusCheck.status}</b> upon completion and cannot be undone.
                                            </p>
                                        </div>
                                        }
                                    </Col>
                                </Row>
                                </Col>
                            </Row> 
                        </> :
                        <>
                            <Row style={{textAlign:"center"}}>
                                <Col xs={12}>
                                    <div>Determining likely completions status.  Please wait...</div>
                                </Col>
                            </Row>
                        </>
                        }              
                    <Row className="button-align">
                            <Col xs={3} md={3} className="d-flex justify-content-center align-items-center">
                                <a href="#!" onClick={onclickCancelhandler} className="modal-cancel" style={{marginLeft: "0"}}>
                                    Cancel
                                </a>
                            </Col>
                            <Col xs={9} md={9} className="d-flex justify-content-center align-items-center">
                            {props.completeStatusCheck.statusId != "0" &&
                                <IconWithButton
                                    buttonText={"Complete ROIS Processing"}
                                    onButtonClick={onClickYesHandler}
                                    isSave={true}
                                    hideArrowIcon={true}
                                    isDisabled={!props.completeStatusCheck.status || !props.feeSchedulesCheck }
                                />
                            }
                            </Col>
                    </Row>
                    </>
                    }
                    </Container>
                    </Modal.Body>
                </div>
            </Modal>
        </div>
    );
}

export const CompleteTransactionWaiting = (props) =>{
    return (
        <div id='wait' className='tx-completing-background' >
         <div className='tx-completing-modal'>
          <div className='tx-completing-header'></div>
          <p>Completing Transaction...</p>
         </div>
      </div> 
    )
}

function mapStateToProps(state: any, props: any) {
    return {
        completeStatusCheck: state.dataEntryState.completeStatusCheck,
        feeSchedulesCheck: state.dataEntryState.feeSchedulesCheck
    }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    getCompleteStatusCheck: (transactionId: string) => dispatch(getCompleteStatusCheckAction(transactionId)),
    getFeeSchedulesCheck: (transactionId: string) => dispatch(getFeeSchedulesCheckAction(transactionId)),
    resetCompleteStatusCheck: () => dispatch(resetCompleteStatusCheckStateAction()),
    resetFeeScheduleCheck: () => dispatch(resetFeeScheduleCheckStateAction())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CompleteTransactionPopUp);
